var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobStress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-1e9e2aaa": "",
    "data-v-304a6410": "",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon medium",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4207 5.11678C20.3752 5.08211 19.9543 4.76902 19.2046 4.46775C18.2388 4.07958 17.1306 3.87439 15.9998 3.87439C14.869 3.87439 13.7608 4.07958 12.7949 4.46775C12.0452 4.76902 11.6243 5.08211 11.5788 5.11683C11.3506 5.29091 11.2166 5.56155 11.2166 5.84861V7.29241L12.1368 7.7846L13.0571 7.29241V6.36973C13.5621 6.11198 14.5721 5.71484 15.9997 5.71484C17.4274 5.71484 18.4373 6.11198 18.9424 6.36973V7.29236L19.8626 7.78455L20.7829 7.29236V5.84861C20.783 5.5615 20.649 5.29085 20.4207 5.11678Z",
    fill: "#224735"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1369 8.30462L11.6541 8.04642V7.72998H12.6197V8.04642L12.1369 8.30462Z",
    fill: "#224735",
    stroke: "#224735",
    strokeWidth: 0.875
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.38 8.04642V7.72998H20.3455V8.04643L19.8627 8.30462L19.38 8.04642Z",
    fill: "#224735",
    stroke: "#224735",
    strokeWidth: 0.875
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.72445 18.4321V26.6075C2.72445 27.578 3.51123 28.3648 4.48177 28.3648H27.5182C28.4888 28.3648 29.2756 27.578 29.2756 26.6075V18.4321H2.72445Z",
    fill: "#429E71"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.72445 17.4161V18.4322C4.18438 19.5914 8.04291 21.8416 16 21.8416C23.9571 21.8416 27.8156 19.5914 29.2756 18.4322V17.416H2.72445V17.4161Z",
    fill: "#429E71"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64816 16.8309C4.04734 17.97 7.90051 20.3016 16 20.3016C24.0995 20.3016 27.9526 17.97 29.3518 16.8309C29.762 16.497 30 15.5044 30 14.9755V10.0659C30 9.09538 29.2132 8.30859 28.2427 8.30859H3.75733C2.78679 8.30859 2 9.09538 2 10.0659V14.9755C2 15.5044 2.238 16.497 2.64816 16.8309Z",
    fill: "#64AB92"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3518 16.3387C27.9527 17.4778 24.0995 19.8093 16 19.8093C7.90051 19.8093 4.04739 17.4777 2.64816 16.3387C2.238 16.0047 2 15.5043 2 14.9755V15.9916C2 16.5205 2.238 17.0209 2.64816 17.3548C4.04734 18.4939 7.90051 20.8255 16 20.8255C24.0995 20.8255 27.9526 18.4939 29.3518 17.3548C29.762 17.0209 30 16.5205 30 15.9916V14.9755C30 15.5043 29.762 16.0047 29.3518 16.3387Z",
    fill: "#224735"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 22.5166C16.909 22.5166 17.6459 21.8416 17.6459 20.3784V19.3803C17.6459 19.0568 17.3836 18.7946 17.0602 18.7946H14.9395C14.616 18.7946 14.3537 19.0568 14.3537 19.3803V20.3785C14.3537 21.8416 15.0907 22.5166 15.9998 22.5166Z",
    fill: "#F5B95F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 22.0245C15.0907 22.0245 14.3537 21.2875 14.3537 20.3784V21.3946C14.3537 22.3037 15.0907 23.0407 15.9998 23.0407C16.909 23.0407 17.6459 22.3037 17.6459 21.3946V20.3784C17.6459 21.2875 16.909 22.0245 15.9998 22.0245Z",
    fill: "#F5B95F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobStress);
export default __webpack_public_path__ + "static/media/job_stress.e9cbfbd761b3fc54d0a289694c476a06.svg";
export { ForwardRef as ReactComponent };